export const titlecase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const createEmptySubtitles = () => {
    return { speech: { finals: [], drafts: [] } };
};
export const addSpeechUnit = (subtitles, unit) => {
    return {
        speech: {
            finals: [...subtitles.speech.finals, ...unit.finals],
            drafts: unit.drafts,
        }
    };
};
//   if (lastSpeech === undefined) {
//     return {
//       speeches: [{
//         final: titlecase(text.trimStart()),
//         speaker,
//         draft: '',
//       }],
//     };
//   }
//   const prevSpeeches = subtitles.speeches.slice(0, -1);
//   if (lastSpeech.speaker !== speaker) {
//     const lastText = lastSpeech.final.trimEnd();
//     const newLastText = lastText.endsWith('.')
//       ? lastText
//       : lastText.endsWith(',')
//         ? lastText.slice(0, -1) + '.'
//         : lastText + '.';
//     const newLastSpeech: Speech = {
//       final: newLastText,
//       speaker: lastSpeech.speaker,
//       draft: '',
//     };
//     return {
//       speeches: [...prevSpeeches, newLastSpeech, {
//         final: titlecase(text.trimStart()),
//         speaker,
//         draft: '',
//       }],
//     };
//   }
//   return {
//     speeches: [...prevSpeeches, {
//       final: lastSpeech.final + text,
//       speaker,
//       draft: '',
//     }],
//   };
// };
// export const updateDraft = (subtitles: Subtitles, text: string, speaker: string): Subtitles => {
//   const lastSpeech = subtitles.speeches.at(-1);
//   if (lastSpeech === undefined || lastSpeech.speaker !== speaker) {
//     return {
//       speeches: [...subtitles.speeches, {
//         final: '',
//         speaker,
//         draft: text,
//       }],
//     };
//   }
//   const prevSpeeches = subtitles.speeches.slice(0, -1);
//   return {
//     speeches: [...prevSpeeches, {
//       ...lastSpeech,
//       draft: text,
//     }],
//   };
// };
